import { render } from "./IntakeRecord.vue?vue&type=template&id=466f791f&scoped=true"
import script from "./IntakeRecord.vue?vue&type=script&lang=js"
export * from "./IntakeRecord.vue?vue&type=script&lang=js"

import "./IntakeRecord.vue?vue&type=style&index=0&id=466f791f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466f791f"]])

export default __exports__